<mat-card class="rental-card" [routerLink]="['/rentals', rental.id]">
  <mat-card-content class="rental-content">
    <div class="rental-top">
      <span class="card-type-badge" *ngIf="showTypeBadge">Прокат</span>
      <ng-container *ngIf="showCarInfo">
        <span class="car-info">
          <span class="rental-car">{{ rental.car_title }}</span>
          <span class="rental-plate" *ngIf="rental.license_plate">{{ rental.license_plate }}</span>
        </span>
      </ng-container>
      <mat-chip-set class="rental-chip">
        <mat-chip [class]="'status-' + rental.status" selected>
          {{ rental.status | statusLabel:'rental' }}
        </mat-chip>
      </mat-chip-set>
    </div>
    <div class="rental-info">
      <span class="rental-client">{{ rental.client_name }}</span>
      <span class="rental-dates">{{ (showHandoverLabel ? 'Выдан: ' : '') + formatDateTime(rental.handover_datetime) }}
        {{rental.return_datetime ? ' - ' + formatDateTime(rental.return_datetime) : ''}}
      </span>
    </div>
  </mat-card-content>
</mat-card>
